<template>
  <div>
   <div class="searchBox">
    <div class="searchLeft">
      <el-input
        size="medium"
        v-model="searchForm.userId"
        placeholder="请输入用户ID"
        type="text" @input="searchForm.userId = String(searchForm.userId).replace(/[^\d]/g,'')"   ng-pattern="/[^a-zA-Z]/"
        @keyup.enter.native="getTableList"
      ></el-input>
      <el-input
        size="medium"
        v-model="searchForm.userName"
        placeholder="请输入真实姓名"
        @keyup.enter.native="getTableList"
      ></el-input>
      <el-input
        size="medium"
        v-model="searchForm.coinName"
        placeholder="请输入币种"
        @keyup.enter.native="getTableList"
      ></el-input>
      <el-date-picker
       size="medium"
        v-model="searchForm.start_time"
        type="date"
        value-format="yyyy-MM-dd"
        :picker-options="pickerOptionsStart"
        placeholder="请选择开始时间">
      </el-date-picker>
      <el-date-picker
        size="medium"
        v-model="searchForm.end_time"
        type="date"
        value-format="yyyy-MM-dd"
        :picker-options="pickerOptionsEnd"
        placeholder="请选择结束时间">
      </el-date-picker>
      <el-button size="medium" type="primary" icon="el-icon-search" @click="getTableList">搜索</el-button>
    </div>
    <div class="searchRight">
      <!-- <el-button size="medium" type="warning" @click="getData"><i class="el-icon-setting" style="margin-right:5px;"></i>提现参数设置</el-button> -->
    </div>
   </div>
   <div class="searchBox" v-if="userId==1">
    <div class="searchLeft">
      <p style="margin-left:20px;display:inline-block;">
        <span>累计提币：</span>
        <span style="color:red;font-size:20px;">{{totalAll+' FIL'}}</span>
      </p>
      <p style="margin-left:20px;display:inline-block;">
        <span>累计提币(未扣手续费)：</span>
        <span style="color:red;font-size:20px;">{{totalApply+' FIL'}}</span>
      </p>
      <p style="margin-left:20px;display:inline-block;">
        <span>Profit Wallet钱包余额：</span>
        <span style="color:red;font-size:20px;">{{balance?balance+' FIL':0}}</span>
      </p>
      <p style="margin-left:20px;display:inline-block;">
        <span>Pleage Wallet钱包余额：</span>
        <span style="color:red;font-size:20px;">{{balanceTwo?balanceTwo+' FIL':0}}</span>
      </p>
    </div>
   </div>
   <el-table
    border
    :data="tableData"
    height="73vh"
    style="width: 100%">
    <el-table-column
      prop="applyTime"
      width="160"
      label="提币时间">
      <template slot-scope="scope">
        <span>{{$selfFunc.dayjsFunc(scope.row.applyTime)}}</span>
      </template>
    </el-table-column>
    <el-table-column
      width="180"
      prop="id"
      label="提币单号">
    </el-table-column>
    <el-table-column
      prop="userId"
      label="用户ID">
    </el-table-column>
    <el-table-column
      prop="userName"
      label="真实姓名">
    </el-table-column>
    <el-table-column
      prop="phone"
      width="120px"
      label="手机号">
    </el-table-column>
    <el-table-column
      prop="email"
      width="200px"
      label="邮箱">
    </el-table-column>
    <el-table-column
      prop="coinName"
      label="币种">
    </el-table-column>
    <el-table-column
      prop="linkName"
      label="链路">
    </el-table-column>
    <el-table-column
      label="提币数量">
      <template slot-scope="scope">
        <span>{{scope.row.applyMoney}}</span>
      </template>
    </el-table-column>
    <el-table-column
      width="400px"
      prop="walletAddr"
      label="提币地址">
    </el-table-column>
    <el-table-column
      prop="actualFee"
      width="100"
      label="提币手续费">
    </el-table-column>
    <el-table-column
      prop="state"
      width="80"
      label="提币状态">
      <template slot-scope="scope">
        <span>{{scope.row.auditStatus==0?"待审核":scope.row.auditStatus==1?"已审核":scope.row.auditStatus==2?"拒绝":"未知"}}</span>
      </template>
    </el-table-column>
    <el-table-column
      prop="state"
      label="链上状态">
      <template slot-scope="scope">
        <span>{{scope.row.transStatus=='PENDING'?"交易中":scope.row.transStatus=='DONE'?"已完成":scope.row.transStatus=='FAILED'?"失败":""}}</span>
      </template>
    </el-table-column>
    <el-table-column fixed="right" label="操作" align="center" prop="time" width="240">
      <template slot-scope="scope" >
        <el-button size="mini" type="primary" @click="checkStatus(scope.row)" v-if="scope.row.transId"><i class="el-icon-view" style="margin-right:3px;" ></i>查看链上信息</el-button>
        <el-button size="mini" type="primary" @click="passList(scope.row)" ><i class="el-icon-view" style="margin-right:3px;"></i>审核明细</el-button>
      </template>
    </el-table-column>
  </el-table>
  <div class="pageBox" v-if="totalNum > 0">
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searchForm.page"
        :page-sizes="[20, 30, 40]"
        :page-size="searchForm.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalNum"
      >
      </el-pagination>
    </div>
    <el-dialog
      title="钱包提现参数设置"
      :visible.sync="dialogVisible"
      width="440px">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="140px" class="demo-ruleForm">
          <el-form-item label="单次提现最小额度" prop="val1" :rules="rules.checkNum1">
              <el-input placeholder="请输入单次提现额度" v-model="ruleForm.val1"></el-input>
              <span class="unit">FIL</span>
          </el-form-item>
          <el-form-item label="每日提现次数" prop="val2" :rules="rules.checkNum">
              <el-input placeholder="请输入每日提现次数" v-model="ruleForm.val2"></el-input>
              <span class="unit">次</span>
          </el-form-item>
          <el-form-item label="人工审核基数" prop="val3" :rules="rules.checkNum1">
              <el-input placeholder="请输入人工审核基数" v-model="ruleForm.val3"></el-input>
              <span class="unit">FIL</span>
          </el-form-item>
          <el-form-item label="单次提现手续费" prop="val4" :rules="rules.checkNum1">
              <el-input placeholder="请输入单次提现手续费" v-model="ruleForm.val4"></el-input>
              <span class="unit">FIL</span>
          </el-form-item>
          <el-form-item label="FIL锁定周期" prop="val3" :rules="rules.checkNum1">
              <el-input placeholder="请输入FIL锁定周期" v-model="ruleForm.val5"></el-input>
              <span class="unit">天</span>
          </el-form-item>
          <el-form-item label="FIL锁定比例" prop="val4" :rules="rules.checkNum1">
              <el-input placeholder="请输入FIL锁定比例" v-model="ruleForm.val6"></el-input>
              <span class="unit">%</span>
          </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="submitForm('ruleForm')">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="审核明细"
      :visible.sync="dialogVisibleTwo"
      width="600px">
        <el-table
        border
        :data="auditRecordsList"
        height="30vh"
        style="width: 100%">
        <el-table-column
          prop="createTime"
          width="160"
          label="审核时间">
        </el-table-column>
        <el-table-column
          prop="auditUser"
          label="审核人">
        </el-table-column>
        <el-table-column
          prop="pass"
          label="审核状态">
          <template slot-scope="scope">
            <span>{{scope.row.pass?'通过':'拒绝'}}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="auditRemark"
          label="审核备注">
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisibleTwo = false">关 闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    var checkNum = (rule, value, callback) => {
      if (value==='') {
        return callback(new Error('输入不能为空'));
      }else {
        if (value !=parseInt(value)) {
          callback(new Error('输入必须为正整数'));
        } else if (value < 0) {
          callback(new Error('输入不能为负值'));
        } else {
          callback();
        }
      }
    };
    var checkNum1 = (rule, value, callback) => {
      if (value==='') {
        return callback(new Error("请输入正确的数值"));
      } else if (value <= 0) {
        callback("输入必须为正数");
      }else {
        callback()
      }
    };
    return {
      pickerOptionsStart: {
        disabledDate: time => {
          let endDateVal = this.searchForm.end_time;
          if (endDateVal) {
            return time.getTime() > new Date(endDateVal).getTime()
          }
        }
      },
      pickerOptionsEnd: {
        disabledDate: time => {
          let beginDateVal = this.searchForm.start_time;
          if (beginDateVal) {
            return (time.getTime()<new Date(beginDateVal).getTime()-1*24*60*60*1000)
          }
        }
      },
      totalNum:0,
      searchForm:{
        page:1,
        pageSize:20,
        start_time:'',
        end_time:'',
        userId:'',
        userName:'',
        coinName:'',
        walletAddr:''
      },
      tableData: [],
      totalAll: 0,
      totalApply: 0,
      dialogVisible:false,
      dialogVisibleTwo: false,
      ruleForm:{
        val1:'',
        val2:'',
        val3:'',
        val4:'',
        val5:'',
        val6:'',
      },
      stateOptions: [
        { name: "全部", value: '' },
        { name: "待审核", value: 0 },
        { name: "审核通过", value: 1 },
        { name: "审核拒绝", value: 2 },
        { name: "已取消", value: 3 }
      ],
      rules:{
        blur:[
          { required: true, message: '请输入', trigger: 'blur' }
        ],
        checkNum:[
          { required: true, validator: checkNum, trigger: 'blur' }
        ],
        checkNum1:[
          { required: true, validator: checkNum1, trigger: 'blur' }
        ],
      },
      userId: '',
      balance: 0,
      balanceTwo: 0,
      auditRecordsList: []
    };
  },
  created() {
    this.getTableList()
    // this.getBalance()
  },
  methods: {
    async passList(row){
      let res = await this.$http.auditRecords({withdrawalId:row.id});
      if (res) {
        this.auditRecordsList = res.data
        this.dialogVisibleTwo = true
      }
    },
    async getBalance () {
      let res = await this.$http.getProfitWalletBalance({});
      if (res) {
        this.balance = res.data.profitWalletBalance
        this.balanceTwo = res.data.pledgeWalletBalance
      }
    },
    checkStatus(row) {
      let url = 'https://filfox.info/zh/message/' + row.transId
      window.open(url, '_blank');
    },
    submitForm(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          let data = {
            WITHDRAWAL_MONEY_MIN_KEY: Number(this.ruleForm.val1),
            WITHDRAWAL_NUMBER_MAX_KEY: Number(this.ruleForm.val2),
            MANUAL_REVIEW_BASE_KEY: Number(this.ruleForm.val3),
            WITHDRAWAL_HANDLING_FEE_KEY: Number(this.ruleForm.val4),
            FIL_LOCK_CYCLE_KEY: Number(this.ruleForm.val5),
            FIL_LOCK_RATIO_KEY: Number(this.ruleForm.val6),
          }
          let res = await this.$http.updateSysConfig({...data})
          if (res) {
            this.$message.success('设置成功！');
            this.dialogVisible=false
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    async getData() {
      this.dialogVisible=true
      let res = await this.$http.configList();
      if (res) {
        // this.ruleForm.val1 = res.data[0].configValue
        res.data.map(item=>{
          if(item.configName == '单次提现最小额度') {
            this.ruleForm.val1 = item.configValue
          } else if (item.configName == '每日提现最大次数') {
            this.ruleForm.val2 = item.configValue
          } else if (item.configName == '人工审核基数(FIL)') {
            this.ruleForm.val3 = item.configValue
          } else if (item.configName == '每笔提现手续费用') {
            this.ruleForm.val4 = item.configValue
          } else if (item.configName == 'FIL锁定周期(天)') {
            this.ruleForm.val5 = item.configValue
          } else if (item.configName == 'FIL锁定比例') {
            this.ruleForm.val6 = item.configValue
          }
        })
      }
    },
    refundAllFunc(){

    },
    async getTableList(val){
      if(val){
        this.searchForm.page=1;
      }
       let res = await this.$http.listPageForAdmin({...this.searchForm});
        if (res) {
          this.tableData=res.data.list
          console.log(res.data)
          this.totalNum=Number(res.data.totalSize)
          // this.totalAll = res.data.total.total
          // this.totalApply = res.data.total.totalApply
        }
    },
    refundFunc(id){
      this.$confirm('确认同意退款？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async () => {
          let res = await this.$http.goodsRefundExamine({id:id,state:2});
          if (res) {
            this.$message.success('操作成功！');
            this.getTableList()
          }
        }).catch(() => {
                
        });
    },
    handleSizeChange(val) {
      this.searchForm.page = 1;
      this.searchForm.pageSize = val;
      this.getTableList();
    },
    handleCurrentChange(val) {
      this.searchForm.page = val;
      this.getTableList();
    }
  }
};
</script>
<style scoped>
.unit{
  position: absolute;
  right: 10px;
  color:#999;
}
</style>
